import * as types from '../actions/types'

const initialState = {
  unreadCount: null,
  list: null,
  current: null,
  loading: false,
}

export default function announcement (state = initialState, action) {
  switch (action.type) {
    case types.SET_ANNOUNCEMENT_COUNT:
      return {
        ...state,
        unreadCount: action.payload
      }
    case types.SET_ANNOUNCEMENT_LIST:
      return {
        ...state,
        list: action.payload
      }
    case types.SET_ANNOUNCEMENT_CURRENT:
      return {
        ...state,
        current: action.payload
      }
    case types.SET_ANNOUNCEMENT_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    default:
      return state
  }
}
